import React, { FC } from 'react'
import { capitalizeString } from 'lib/helpers'
import Breadcrumb from 'components/SA/Breadcrumb'

type CollectionDetailsBreadcrumbProps = {
  collectionOwnerName: string
  collectionOwnerId: string
}

const CollectionDetailsBreadcrumb: FC<CollectionDetailsBreadcrumbProps> = ({
  collectionOwnerName,
  collectionOwnerId,
}) => {
  const capitalizedName = capitalizeString(collectionOwnerName)

  return (
    <Breadcrumb
      items={[
        {
          name: 'All Artworks',
          title: 'See all artworks',
          url: '/all',
        },
        {
          name: 'Collections',
          title: 'Collections',
          url: '/collections',
        },
        {
          name: `${capitalizedName} Collections`,
          title: `${capitalizedName} Collections`,
          url: `/account/collection/${collectionOwnerId}`,
        },
      ]}
    />
  )
}

export default CollectionDetailsBreadcrumb
